import { UserAccountApi, useAPIAction } from "melco-shared-logic";
import { useCallback } from "react";

export const useDeleteAllNotifications = () => {
  const [deleteAllNotifications] = useAPIAction(
    UserAccountApi,
    async (api) => {
      const data = await api.userProductNotificationsDeleteByProduct({
        productCode: process.env.REACT_APP_PRODUCT_CODE!,
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "notifications.actions.delete_all",
    }
  );

  return useCallback(async () => {
    try {
      await deleteAllNotifications();
    } catch (e) {
      // error handling is already done in useAPIAction
    }
  }, [deleteAllNotifications]);
};
